import { BlankSlate, Box, Button, Link, Tag } from '@factorialco/deprecated-design-system'
import illustration from 'assets/images/competencies/competencies.png'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onNewCompetency: () => void
}

const SetUpCompetencies = ({ onNewCompetency }: Props) => {
  const jobs = [
    i18n.t('competencies_v3.set_up_competencies.jobs.accountant'),
    i18n.t('competencies_v3.set_up_competencies.jobs.accounts_payable_specialist'),
    i18n.t('competencies_v3.set_up_competencies.jobs.audit_associate'),
    i18n.t('competencies_v3.set_up_competencies.jobs.controller'),
    i18n.t('competencies_v3.set_up_competencies.jobs.financial_analyst'),
    i18n.t('competencies_v3.set_up_competencies.jobs.it_services'),
    i18n.t('competencies_v3.set_up_competencies.jobs.go_engineer'),
    i18n.t('competencies_v3.set_up_competencies.jobs.marketer'),
  ]

  return (
    <BlankSlate
      illustration="window-user"
      title={i18n.t('competencies_v3.set_up_competencies.title')}
      description={i18n.t('competencies_v3.set_up_competencies.description')}
    >
      <Box gap="s24" alignItems="center">
        <Button onClick={() => onNewCompetency()} iconName="add">
          {i18n.t('competencies_v3.set_up_competencies.create_button')}
        </Button>
        {/* TODO: add link to competencies help center article once we have it */}
        <Link.Href href="#" target="_blank">
          {i18n.t('competencies_v3.set_up_competencies.help_link')}
        </Link.Href>
        <Box
          flexDirection="row"
          gap="s4"
          maxWidth="s600"
          flexWrap="wrap"
          justifyContent="center"
          paddingBottom="s24"
        >
          {jobs.map((job) => (
            <Tag key={job}>{job}</Tag>
          ))}
        </Box>
        <img
          src={illustration}
          alt={i18n.t('competencies_v3.set_up_competencies.illustration_alt')}
          title={i18n.t('competencies_v3.set_up_competencies.illustration_alt')}
        />
      </Box>
    </BlankSlate>
  )
}

export default SetUpCompetencies
